type StoreCityFilterProps = {
  cities: string[];
  selectedCity: string | 'all';
  onChange: (city: string | 'all') => void;
};

export function StoreCityFilter({ cities, selectedCity, onChange }: StoreCityFilterProps) {
  return (
    <div className="flex items-center justify-end gap-2 px-4 py-3">
      <label htmlFor="store-city-filter" className="text-sm text-gray-600">
        Filter by city
      </label>
      <select
        id="store-city-filter"
        value={selectedCity}
        onChange={(e) => onChange(e.target.value === 'all' ? 'all' : e.target.value)}
        className="rounded border border-gray-300 bg-white px-3 py-1.5 text-sm text-gray-800 focus:border-[#4A7B9D] focus:outline-none"
      >
        <option value="all">All</option>
        {cities.map((city) => (
          <option key={city} value={city}>
            {city}
          </option>
        ))}
      </select>
    </div>
  );
}
